import { Modal, useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import { memo, useEffect, useState } from 'react';
import { Logger, type AppState } from '@nextgen-web-framework/core';
import { useDispatch, useSelector } from 'react-redux';
import { updateApiErrorData } from '@commerce-profile-webcomponents/sdk';
import { getErrorTranslationMsg } from '../../utils/registrationUtils';
import { ERROR_GENERIC_MESSAGE } from '../../utils/Constants';
import { ApiErrorModalProps } from './types/propTypes';

const ApiErrorModal = ({
  headline,
  body,
  fallbackBody,
  primaryButtonLabel,
  primaryButtonCallback,
}: ApiErrorModalProps) => {
  const loggerService = Logger.getInstance();
  const t = useTranslation();
  const router = useNextgenRouter();
  const dispatch = useDispatch();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const apiError = useSelector((state: AppState) => state.commerceProfile.apiErrorData);

  useEffect(() => {
    if (headline || body || fallbackBody || apiError?.message) {
      loggerService.log(apiError, apiError?.message);
      setShowErrorModal(true);
    }
  }, [apiError, headline, body, fallbackBody]);

  const errorHeadline = headline ?? ERROR_GENERIC_MESSAGE.headline;
  const errorBody = body ?? fallbackBody ?? ERROR_GENERIC_MESSAGE.body;

  const headlineMessage = getErrorTranslationMsg(errorHeadline, t, ERROR_GENERIC_MESSAGE.headline);
  const bodyMessage = getErrorTranslationMsg(errorBody, t, fallbackBody);

  const redirectToHomeCallback = () => {
    loggerService.log('fallback exec');
    if (apiError?.message) {
      dispatch(updateApiErrorData({}));
      router.push('/'); // if service down then back to home
    }
  };

  function onPrimaryBtnClick() {
    setShowErrorModal(false);
    primaryButtonCallback?.() ?? redirectToHomeCallback();
  }
  return (
    <>
      {showErrorModal && (
        <Modal
          headline={headlineMessage}
          primaryButtonLabel={primaryButtonLabel ? t(primaryButtonLabel) : t('profile.ApiErrorModal.close')}
          onPrimaryButtonClick={onPrimaryBtnClick}
          closeIcon={false}
        >
          <span data-testid="error-modal-conatiner">{bodyMessage}</span>
        </Modal>
      )}
    </>
  );
};

export default memo(ApiErrorModal);
